import { ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import { ListarBancosController } from "../../../../Controllers/Geral/ListarBancosController/ListarBancosController";
import { IAtendimentoRepasseCaso } from "../../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";

import { formatMoneyReais } from "../../../../Tools/FormatTools";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";
import UnForm from "../../../Form";

interface IRepasseFinanceiroProps {
    gestaoRepasseDados: IAtendimentoRepasseCaso;
}

interface IGestaoRepasseDadosConfirmado {
    DS_BANCO: string;
    VL_FINANCIAMENTO_CONFIRMADO: number;
    VL_FGTS_CONFIRMADO: number;
    VL_SUBSIDIO_CONFIRMADO: number;
    VL_RECURSOS_PROPRIOS_CONFIRMADO: number;
    VL_A_CONFIRMAR: number;
    VL_A_CONFIRMAR_MAX: number;
    VL_FINANCIAMENTO_CONFIRMADO_MAX: number;
    VL_FGTS_CONFIRMADO_MAX: number;
    VL_SUBSIDIO_CONFIRMADO_MAX: number;
}

export default function RepasseFinanceiro(props: IRepasseFinanceiroProps) {
    const formMethods = useFormContext<IGestaoRepasseDadosConfirmado>();
    const calculoFinanceiroFormWatcher = formMethods.watch();

    function geradorMascaraFinanceira(
        inputName: keyof IGestaoRepasseDadosConfirmado
    ) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            formMethods.setValue(inputName, mask);
        };
    }
    const valorDiferencaRP =
        (props.gestaoRepasseDados?.VL_ORIGINAL ?? 0) -
        (props.gestaoRepasseDados.VL_FINANCIAMENTO ?? 0) -
        (props.gestaoRepasseDados.VL_FGTS ?? 0) -
        (props.gestaoRepasseDados.VL_SUBSIDIO ?? 0);

    const valorDiferencaMaxAprovado =
        calculoFinanceiroFormWatcher.VL_A_CONFIRMAR_MAX -
        calculoFinanceiroFormWatcher.VL_FINANCIAMENTO_CONFIRMADO_MAX -
        calculoFinanceiroFormWatcher.VL_FGTS_CONFIRMADO_MAX -
        calculoFinanceiroFormWatcher.VL_SUBSIDIO_CONFIRMADO_MAX;

    const valorDiferencaCompraEVenda =
        (props.gestaoRepasseDados.VL_A_CONFIRMAR ?? 0) -
        calculoFinanceiroFormWatcher.VL_A_CONFIRMAR;

    const valorDiferencaConfirmado =
        calculoFinanceiroFormWatcher.VL_A_CONFIRMAR -
        calculoFinanceiroFormWatcher.VL_FINANCIAMENTO_CONFIRMADO -
        calculoFinanceiroFormWatcher.VL_FGTS_CONFIRMADO -
        calculoFinanceiroFormWatcher.VL_SUBSIDIO_CONFIRMADO;

    const valorDiferencaFinanciamento =
        calculoFinanceiroFormWatcher.VL_FINANCIAMENTO_CONFIRMADO -
        (props.gestaoRepasseDados?.VL_FINANCIAMENTO ?? 0);

    const valorDiferencaFGTS =
        calculoFinanceiroFormWatcher.VL_FGTS_CONFIRMADO -
        (props.gestaoRepasseDados?.VL_FGTS ?? 0);

    const valorDiferencaSubsidio =
        calculoFinanceiroFormWatcher.VL_SUBSIDIO_CONFIRMADO -
        (props.gestaoRepasseDados?.VL_SUBSIDIO ?? 0);

    const valorDiferencaRecursosProprios =
        (props.gestaoRepasseDados.VL_A_CONFIRMAR ?? 0) -
        calculoFinanceiroFormWatcher.VL_A_CONFIRMAR -
        ((props.gestaoRepasseDados.VL_RECURSOS_PROPRIOS ?? 0) -
            calculoFinanceiroFormWatcher.VL_RECURSOS_PROPRIOS_CONFIRMADO) -
        ((props.gestaoRepasseDados.VL_FINANCIAMENTO ?? 0) -
            calculoFinanceiroFormWatcher.VL_FINANCIAMENTO_CONFIRMADO) -
        ((props.gestaoRepasseDados.VL_SUBSIDIO ?? 0) -
            calculoFinanceiroFormWatcher.VL_SUBSIDIO_CONFIRMADO) -
        ((props.gestaoRepasseDados.VL_FGTS ?? 0) -
            calculoFinanceiroFormWatcher.VL_FGTS_CONFIRMADO);

    const valorDiferencaTotal =
        calculoFinanceiroFormWatcher.VL_FINANCIAMENTO_CONFIRMADO -
        (props.gestaoRepasseDados?.VL_FINANCIAMENTO ?? 0) +
        calculoFinanceiroFormWatcher.VL_FGTS_CONFIRMADO -
        (props.gestaoRepasseDados?.VL_FGTS ?? 0) +
        calculoFinanceiroFormWatcher.VL_SUBSIDIO_CONFIRMADO -
        (props.gestaoRepasseDados?.VL_SUBSIDIO ?? 0);

    return (
        <div className="d-flex row col-12 justify-content-between aling-item-center p-4">
            <div className="d-flex row col-sm justify-content-between aling-item-center p-4">
                <div className="col-12 col-md-auto ">
                    <h4>Valor RP</h4>
                    <div style={{ height: 80 }}>
                        <p>Banco:</p>
                        <span>{props.gestaoRepasseDados?.DS_BANCO}</span>
                    </div>
                    <div style={{ height: 80 }}>
                        <p>Compra e Venda:</p>
                        <span>
                            {formatMoneyReais(
                                props.gestaoRepasseDados?.VL_ORIGINAL ?? 0
                            )}
                        </span>
                    </div>
                    <div style={{ height: 80 }}>
                        <p>Financiamento:</p>
                        <span>
                            {formatMoneyReais(
                                props.gestaoRepasseDados?.VL_FINANCIAMENTO ?? 0
                            )}
                        </span>
                    </div>
                    <div style={{ height: 80 }}>
                        <p>FGTS:</p>
                        <span>
                            {formatMoneyReais(
                                props.gestaoRepasseDados?.VL_FGTS ?? 0
                            )}
                        </span>
                    </div>
                    <div style={{ height: 80 }}>
                        <p>Subsídio / Subvenção:</p>
                        <span>
                            {formatMoneyReais(
                                props.gestaoRepasseDados?.VL_SUBSIDIO ?? 0
                            )}
                        </span>
                    </div>
                    <div style={{ height: 80 }}>
                        <p>Recursos Próprios:</p>
                        <span>{formatMoneyReais(valorDiferencaRP)}</span>
                    </div>
                </div>
                <div className="col-12 col-md-auto">
                    <h4>Valor Máx. Aprovado</h4>
                    <div style={{ height: 80, marginTop: 88 }}>
                        <UnForm.Input
                            wrapperClassName="col-12 mb-3"
                            label="Compra e Venda:"
                            name="VL_A_CONFIRMAR_MAX"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_A_CONFIRMAR_MAX"
                            )}
                            defaultValue={formatMoneyReais(
                                props.gestaoRepasseDados.VL_A_CONFIRMAR_MAX ?? 0
                            )}
                        ></UnForm.Input>
                    </div>
                    <div style={{ height: 80 }}>
                        <UnForm.Input
                            wrapperClassName="col-12 mb-3"
                            label="Financiamento:"
                            name="VL_FINANCIAMENTO_CONFIRMADO_MAX"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_FINANCIAMENTO_CONFIRMADO_MAX"
                            )}
                            defaultValue={formatMoneyReais(
                                props.gestaoRepasseDados
                                    .VL_FINANCIAMENTO_CONFIRMADO_MAX ?? 0
                            )}
                        ></UnForm.Input>
                    </div>

                    <div style={{ height: 80 }}>
                        <UnForm.Input
                            wrapperClassName="p-4 bd-highlight col-6 mb-3"
                            label="FGTS:"
                            name="VL_FGTS_CONFIRMADO_MAX"
                            registerOptions={{
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_FGTS_CONFIRMADO_MAX"
                            )}
                            defaultValue={formatMoneyReais(
                                props.gestaoRepasseDados
                                    .VL_FGTS_CONFIRMADO_MAX ?? 0
                            )}
                        ></UnForm.Input>
                    </div>

                    <div style={{ height: 80 }}>
                        <UnForm.Input
                            wrapperClassName="p-4 bd-highlight col-12 mb-3"
                            label="Subsídio / Subvenção:"
                            name="VL_SUBSIDIO_CONFIRMADO_MAX"
                            registerOptions={{
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_SUBSIDIO_CONFIRMADO_MAX"
                            )}
                            defaultValue={formatMoneyReais(
                                props.gestaoRepasseDados
                                    .VL_SUBSIDIO_CONFIRMADO_MAX ?? 0
                            )}
                        ></UnForm.Input>
                    </div>
                    <div style={{ height: 80 }}>
                        <UnForm.Input
                            wrapperClassName="p-4 bd-highlight col-12 mb-3"
                            label="Recursos Próprios"
                            name="VL_RECURSOS_PROPRIOS_CONFIRMADO_MAX"
                            registerOptions={{
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            value={formatMoneyReais(valorDiferencaMaxAprovado)}
                            readOnly
                        ></UnForm.Input>
                    </div>
                </div>

                <div className="col-12 col-md-auto">
                    <h4>Valor Banco</h4>

                    <div style={{ height: 80 }}>
                        <UnForm.LazySelect
                            controller={ListarBancosController}
                            label="Banco"
                            name="ID_BANCO"
                            className={`form-control placeholder-dark-50`}
                            wrapperClassName="col-md-6 mb-5 col-lg-3"
                            getDS={(b) => b.DS_BANCO}
                            getKeyValue={(b) => b.ID_BANCO}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                    <div style={{ height: 80 }}>
                        <UnForm.Input
                            wrapperClassName="col-12 mb-3"
                            label="Compra e Venda:"
                            name="VL_A_CONFIRMAR"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_A_CONFIRMAR"
                            )}
                            defaultValue={formatMoneyReais(
                                props.gestaoRepasseDados.VL_A_CONFIRMAR ?? 0
                            )}
                        ></UnForm.Input>
                    </div>
                    <div style={{ height: 80 }}>
                        <UnForm.Input
                            wrapperClassName="col-12 mb-3"
                            label="Financiamento:"
                            name="VL_FINANCIAMENTO_CONFIRMADO"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_FINANCIAMENTO_CONFIRMADO"
                            )}
                            defaultValue={formatMoneyReais(
                                props.gestaoRepasseDados
                                    .VL_FINANCIAMENTO_CONFIRMADO ?? 0
                            )}
                        ></UnForm.Input>
                    </div>

                    <div style={{ height: 80 }}>
                        <UnForm.Input
                            wrapperClassName="p-4 bd-highlight col-6 mb-3"
                            label="FGTS:"
                            name="VL_FGTS_CONFIRMADO"
                            registerOptions={{
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_FGTS_CONFIRMADO"
                            )}
                            defaultValue={formatMoneyReais(
                                props.gestaoRepasseDados.VL_FGTS_CONFIRMADO ?? 0
                            )}
                        ></UnForm.Input>
                    </div>

                    <div style={{ height: 80 }}>
                        <UnForm.Input
                            wrapperClassName="p-4 bd-highlight col-12 mb-3"
                            label="Subsídio / Subvenção:"
                            name="VL_SUBSIDIO_CONFIRMADO"
                            registerOptions={{
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_SUBSIDIO_CONFIRMADO"
                            )}
                            defaultValue={formatMoneyReais(
                                props.gestaoRepasseDados
                                    .VL_SUBSIDIO_CONFIRMADO ?? 0
                            )}
                        ></UnForm.Input>
                    </div>
                    <div style={{ height: 80 }}>
                        <UnForm.Input
                            wrapperClassName="p-4 bd-highlight col-12 mb-3"
                            label="Recursos Próprios"
                            name="VL_RECURSOS_PROPRIOS_CONFIRMADO"
                            registerOptions={{
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            value={formatMoneyReais(valorDiferencaConfirmado)}
                            readOnly
                        ></UnForm.Input>
                    </div>
                </div>

                <div className="col-12 col-md-auto">
                    <h4>Valor Final</h4>

                    <div style={{ height: 80 }}>
                        <p>Banco:</p>
                        <span>{props.gestaoRepasseDados?.DS_BANCO}</span>
                    </div>

                    <div style={{ height: 80 }}>
                        <p>Compra e Venda:</p>
                        {valorDiferencaCompraEVenda >= 0 ? (
                            <span
                                style={{
                                    color: "green",
                                    fontWeight: "bold",
                                }}
                            >
                                {formatMoneyReais(valorDiferencaCompraEVenda)}
                            </span>
                        ) : (
                            <span
                                style={{
                                    color: "red",
                                    fontWeight: "bold",
                                }}
                            >
                                {" "}
                                {formatMoneyReais(valorDiferencaCompraEVenda)}
                            </span>
                        )}
                    </div>
                    <div style={{ height: 80 }}>
                        <p>Financiamento:</p>
                        {valorDiferencaFinanciamento >= 0 ? (
                            <span
                                style={{
                                    color: "green",
                                    fontWeight: "bold",
                                }}
                            >
                                {formatMoneyReais(valorDiferencaFinanciamento)}
                            </span>
                        ) : (
                            <span
                                style={{
                                    color: "red",
                                    fontWeight: "bold",
                                }}
                            >
                                {" "}
                                {formatMoneyReais(valorDiferencaFinanciamento)}
                            </span>
                        )}
                    </div>
                    <div style={{ height: 80 }}>
                        <p>FGTS:</p>
                        {valorDiferencaFGTS >= 0 ? (
                            <span
                                style={{
                                    color: "green",
                                    fontWeight: "bold",
                                }}
                            >
                                {formatMoneyReais(valorDiferencaFGTS)}
                            </span>
                        ) : (
                            <span
                                style={{
                                    color: "red",
                                    fontWeight: "bold",
                                }}
                            >
                                {" "}
                                {formatMoneyReais(valorDiferencaFGTS)}
                            </span>
                        )}
                    </div>
                    <div style={{ height: 80 }}>
                        <p>Subsídio / Subvenção:</p>
                        {valorDiferencaSubsidio >= 0 ? (
                            <span
                                style={{
                                    color: "green",
                                    fontWeight: "bold",
                                }}
                            >
                                {formatMoneyReais(valorDiferencaSubsidio)}
                            </span>
                        ) : (
                            <span
                                style={{
                                    color: "red",
                                    fontWeight: "bold",
                                }}
                            >
                                {" "}
                                {formatMoneyReais(valorDiferencaSubsidio)}
                            </span>
                        )}
                    </div>
                    <div style={{ height: 80 }}>
                        <p>Recursos Próprios:</p>
                        {valorDiferencaRecursosProprios >= 0 ? (
                            <span
                                style={{
                                    color: "green",
                                    fontWeight: "bold",
                                }}
                            >
                                {formatMoneyReais(
                                    valorDiferencaRecursosProprios
                                )}
                            </span>
                        ) : (
                            <span
                                style={{
                                    color: "red",
                                    fontWeight: "bold",
                                }}
                            >
                                {" "}
                                {formatMoneyReais(
                                    valorDiferencaRecursosProprios
                                )}
                            </span>
                        )}
                    </div>
                    <div style={{ height: 80 }}>
                        <h6 style={{ fontWeight: "bold" }}>Diferença Total:</h6>

                        <div>
                            {calculoFinanceiroFormWatcher &&
                                props.gestaoRepasseDados && (
                                    <span
                                        style={{
                                            fontWeight: "bold",
                                            height: 80,
                                            color:
                                                calculoFinanceiroFormWatcher.VL_FINANCIAMENTO_CONFIRMADO -
                                                    props.gestaoRepasseDados
                                                        ?.VL_FINANCIAMENTO +
                                                    calculoFinanceiroFormWatcher.VL_FGTS_CONFIRMADO -
                                                    props.gestaoRepasseDados
                                                        ?.VL_FGTS +
                                                    calculoFinanceiroFormWatcher.VL_SUBSIDIO_CONFIRMADO -
                                                    props.gestaoRepasseDados
                                                        ?.VL_SUBSIDIO <
                                                0
                                                    ? "red "
                                                    : "green ",
                                        }}
                                    >
                                        {formatMoneyReais(valorDiferencaTotal)}
                                    </span>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
